import { EntityModel } from '@cksoftware/react-base';

export type Advertisement = EntityModel & {
  Name: string;
  Url: string;
  PositionId: number;
  Position: string;
  ImageUrl: string;
  ImageId: string;
};

export enum AdvertisementPosition {
  Unknown = 0,
  General = 1,
  NavbarOne = 2,
  NavbarTwo = 3,
  NavbarThree = 4,
  MarketReport = 5
} // todo get these from the backend

export type AdvertisementFormModel = Advertisement & {};
